export default {
  lookups: {},
  groups: [],
  timeZones: [],
  countries: [],
  stateProvinces: [],
  languages: []
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/state.js